import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

function SensorGroupSelect({ selectedGroup, onChange, groups }) {
  return (
    <FormControl size="small">
      <InputLabel id="sensor-group-label">Группа датчиков</InputLabel>
      <Select
        labelId="sensor-group-label"
        value={selectedGroup}
        label="Группа датчиков"
        onChange={onChange}
        sx={{ minWidth: '124px', width: '100%' }}
      >
        <MenuItem value="all">Все</MenuItem>
        {groups.map((group) => (
          <MenuItem key={group} value={group}>
            {group}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

SensorGroupSelect.propTypes = {
  selectedGroup: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  groups: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default SensorGroupSelect;
